export default "__VITE_ASSET__CuIsYXly__"